import { CargoReportEnum } from '../enums/cargoReportEnum';
import { CargoTemperatureLogDateBM } from 'src/types/BusinessModel/CargoTempLog/CargoTemperatureLogDateBM';
import { CargoInfo } from 'src/types/ViewModel/CargoTempLog/CargoInfo';

export default () => {
    const createExcelReportInfoBM = (
        reportType: CargoReportEnum,
        imoNumber: number | null,
        portCallId: number | null,
        isPortCluster: boolean,
        selectedBerthCallIdList: any[],
        totalBerthCallIdList: any[],
        chartererNameList: string | null,
        cargoOperationIdList: string | null,
        eventId: string | null,
        filename: string,
        portId: number,
        berthId: number | null,
        cargoTempLogInfo: {
            cargoNumbers: string | null;
            voyageNumber: string | null;
            includeAdjacentTanks: boolean | null;
            printableFormat: boolean | null;
            useOrcaWebStowage: boolean | null;
            cargoData: CargoInfo[] | null;
            cargoTemperatureLogDates: CargoTemperatureLogDateBM[] | null;
        } | null
    ): any => {
        return {
            reportType: reportType,
            imoNumber: imoNumber,
            portCallId: portCallId,
            isPortCluster: isPortCluster,
            selectedBerthCallIdList: selectedBerthCallIdList,
            totalBerthCallIdList: totalBerthCallIdList,
            chartererNameList: chartererNameList,
            cargoOperationIdList: cargoOperationIdList,
            eventId: eventId,
            filename: filename,
            portId: portId,
            berthId: berthId,
            cargoTempLogInfo: cargoTempLogInfo,
        };
    };

    return {
        createExcelReportInfoBM,
    };
};
